export default class DataReportBlock<T> {
  data: T[];
  constructor(obj?: DataReportBlock<T>) {
    this.data = (obj && obj.data) || [];
  }
}

// Merge older data into a report block.
export const mergeReportBlock = (
  dest: Record<string, unknown>,
  key: string,
  src?: unknown
): void => {
  if (src instanceof DataReportBlock && src.data.length > 0) {
    const dst = dest[key];
    if (dst instanceof DataReportBlock) {
      dst.data.unshift(...src.data);
    } else {
      dest[key] = new DataReportBlock({ data: [...src.data] });
    }
  }
};
